import Icon from 'veui/components/Icon'
import { IconVideoFilm } from 'dls-icons-vue'

Icon.register('video-film', IconVideoFilm)
